(function() {
  const style = document.createElement('style');
  style.innerHTML = `
    .joy-redeem-inline { min-height: 40px; width: 100%; margin-bottom: 12px; display: flex; justify-content: center; align-items: center; border-bottom: .5px solid #e9e7e7;}
    .joy-skeleton-box { 
      border-radius: 8px; 
    }
    .joy-skeleton-text {width: 100%; display: flex; justify-content: center; font-size: calc(var(--g-p2-size) + 2px);}
    .joy-skeleton-text a :is(.joy-skeleton-text-action) {font-weight: 700;}
    .joy-skeleton-text-action {text-decoration: underline; color: var(--qsc2-btn-bg); text-decoration-color: var(--qsc2-btn-bg);}
  `;
  document.head.appendChild(style);

  function injectRedeemInline() {
    console.log("begin inject redeem inline");
    if (document.querySelector('.qsc2-drawer-footer .joy-redeem-inline')) {
      return;
    }

    const footer = document.querySelector('.qsc2-drawer-footer');
    if (!footer) return;

    const redeemDiv = document.createElement('div');
    redeemDiv.className = 'joy-redeem-inline';

    redeemDiv.innerHTML = `
        <div class="joy-skeleton-text">
        <div>
  <a href="/account/register"><span class="joy-skeleton-text-action">เข้าสู่ระบบ</span></a>
    <span> or </span>
  <a href="/account/register"><span class="joy-skeleton-text-action">ลงทะเบียน
</span>.</a>
    <span> รับส่วนลด 5% สำหรับครั้งแรก</span>
</div>
    `;

    footer.insertBefore(redeemDiv, footer.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectRedeemInline);
  } else {
    injectRedeemInline();
    console.log("injected");
  }

  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldCheck = true;
        break;
      }
    }
    if (shouldCheck) injectRedeemInline();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();